import React from "react";
import { useRouter } from "next/router";
import Image from "next/image";
import useTranslation from "next-translate/useTranslation";
import { ArrowRightIcon } from "@heroicons/react/outline";
import NextLink, { removeLangFromHref } from "components/NextLink";

export default function NodePageMenuItem({ item }) {
  const router = useRouter();
  const { t, lang } = useTranslation("common");

  return (
    <div
      className="group relative grid grid-cols-1 lg:grid-cols-2 h-full bg-primary text-white rounded-lg shadow-spread overflow-hidden cursor-pointer hover:bg-primary-dark transition-colors"
      onClick={() => router.push(removeLangFromHref(item.url, lang))}
    >
      <div className="relative">
        {item.node && item.node.field_image ? (
          <Image
            src={item.node.field_image.image_style_uri.medium}
            {...item.node.field_image.resourceIdObjMeta}
            layout="fill"
            objectFit="cover"
            objectPosition="center"
            quality={100}
          />
        ) : (
          <Image
            src="/images/header.jpg"
            width="231"
            height="220"
            layout="fill"
            objectFit="cover"
            objectPosition="center"
            quality={100}
            alt="Bannière d'en-tête"
          />
        )}
      </div>
      <div className="p-10">
        <div className="font-important text-xl mb-8">{item.title}</div>
        <NextLink
          href={item.url}
          className="inline-block bg-white rounded-full p-2"
        >
          <ArrowRightIcon className="w-5 h-5 text-primary" />
          <span className="sr-only">{t("utils.more_link")}</span>
        </NextLink>
      </div>
    </div>
  );
}
